var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#EDFEF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 16.5V13.5H17.625C17.1277 13.5 16.6508 13.6975 16.2992 14.0492C15.9475 14.4008 15.75 14.8777 15.75 15.375V26.625C15.75 27.1223 15.9475 27.5992 16.2992 27.9508C16.6508 28.3025 17.1277 28.5 17.625 28.5H25.125C25.6223 28.5 26.0992 28.3025 26.4508 27.9508C26.8025 27.5992 27 27.1223 27 26.625V18.75H24C23.4033 18.75 22.831 18.5129 22.409 18.091C21.9871 17.669 21.75 17.0967 21.75 16.5ZM24 17.25H27C26.9983 16.8528 26.8392 16.4725 26.5575 16.1925L24.3075 13.9425C24.0275 13.6608 23.6472 13.5017 23.25 13.5V16.5C23.25 16.6989 23.329 16.8897 23.4697 17.0303C23.6103 17.171 23.8011 17.25 24 17.25Z",
    fill: "#00A852"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.fd733c61ae80bb0be64f39ed23a6a039.svg";
export { ForwardRef as ReactComponent };